import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _Form from "@hzero-front-ui/hzero-ui/lib/Form";
var _excluded = ["selectBox", "treeSelect"];
import React from "react";
import { ConfigStepContainer, StyledConfigRow } from "./index.style";
import PaginationConfig from "../ComponentsConfig/PaginationConfig";
import SliderConfig from "../ComponentsConfig/SliderConfig";
import SelectBoxConfig from "../ComponentsConfig/SelectBoxConfig";
import SwitchConfig from "../ComponentsConfig/SwitchConfig";
import TransferConfig from "../ComponentsConfig/TransferConfig";
import TreeSelectConfig from "../ComponentsConfig/TreeSelectConfig";
var ConfigStepTwo = function ConfigStepTwo(_ref) {
  var form = _ref.form,
    config = _ref.config;
  var getFieldDecorator = form.getFieldDecorator;
  return /*#__PURE__*/React.createElement(ConfigStepContainer, null, /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator("pagination", {
    initialValue: config.pagination
  })( /*#__PURE__*/React.createElement(PaginationConfig, null))), /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator("slider", {
    initialValue: config.slider
  })( /*#__PURE__*/React.createElement(SliderConfig, null))), /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator("selectBox", {
    initialValue: {
      radio: config.radio,
      checkbox: config.checkbox,
      checkboxBtn: config.checkboxBtn
    }
  })( /*#__PURE__*/React.createElement(SelectBoxConfig, null))), /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator("switch", {
    initialValue: config.switch
  })( /*#__PURE__*/React.createElement(SwitchConfig, null))), /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator("transfer", {
    initialValue: config.transfer
  })( /*#__PURE__*/React.createElement(TransferConfig, null))), /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator("treeSelect", {
    initialValue: {
      tree: config.tree,
      treeCheck: config.treeCkeck
    }
  })( /*#__PURE__*/React.createElement(TreeSelectConfig, null))));
};
export default _Form.create({
  onValuesChange: function onValuesChange(props, field, values) {
    var selectBox = values.selectBox,
      treeSelect = values.treeSelect,
      rest = _objectWithoutProperties(values, _excluded);
    if (props.onChange) {
      props.onChange(_objectSpread(_objectSpread(_objectSpread({}, rest), treeSelect), selectBox));
    }
  }
})(ConfigStepTwo);